import {
  ButtonView,
  ImageScaleView,
  View,
  ViewOpts,
} from '@play-co/timestep-core/ui';
import { downscale } from 'src/conf/scale';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { buddiesEligibilityMultipliers } from 'src/replicant/buddies/buddies.ruleset';

export type BuddiesBakerChestOpts = ViewOpts & {
  index: number;
  onInvite?: () => Promise<void>;
};

export class BuddiesBakerChest extends ButtonView {
  constructor(opts: BuddiesBakerChestOpts) {
    super({
      width: 150,
      height: 200,
      centerOnOrigin: true,
      ...opts,
      onClick: async () => opts?.onInvite?.(),
    });

    // Default to chest_1 if index is 0
    const chestIndex = opts.index || 1;

    new ImageScaleView({
      superview: this,
      image: `assets/ui/buddies/popupBaking/chest_${chestIndex}.png`,
      width: downscale(237),
      height: downscale(207),
      centerOnOrigin: true,
      x: this.style.width / 2 + 8,
      y: 55,
    });

    const tab = new ImageScaleView({
      superview: this,
      image: 'assets/ui/buddies/popupBaking/multiplier_tab.png',
      width: downscale(213),
      height: downscale(142),
      centerOnOrigin: true,
      x: this.style.width / 2,
      y: 160,
    });

    // First multiplier is the base one
    const multiplier = buddiesEligibilityMultipliers[opts.index + 1];

    // Multiplier text should show up with .0 if round number: 1.0x, 1.5x, 2.0x, etc.
    const multiplierText = `${multiplier.toFixed(1)}x`;

    new LangBitmapFontTextView({
      superview: this,
      align: 'center',
      x: tab.style.x,
      y: tab.style.y + 5,
      size: 30,
      font: 'Body',
      color: '#754A22',
      width: this.style.width - 10,
      height: 40,
      centerOnOrigin: true,
      localeText: () => multiplierText,
    });
  }
}
